/**
 * CA Auth OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Cookie { 
    attributes?: { [key: string]: string; };
    comment?: string;
    domain?: string;
    httpOnly?: boolean;
    maxAge?: number;
    name?: string;
    path?: string;
    secure?: boolean;
    value?: string;
    version?: number;
}

